<template>
  <div>

    <breadcrumbs />

    <loading :active.sync="isLoading"></loading>

    <div class="content-i">
      <div class="content-box">
        <div class="row pt-4">
          <div class="col-sm-12">
            <!--START - User List -->
            <div class="element-wrapper">
              <h6 class="element-header capitalize">
                {{ t.navigation.sport }}
              </h6>
              <div class="element-box-tp">
                  <a class="btn btn-primary pull-right mb-2" @click="saveSportPost">
                    Save
                  </a>
                  <table class="table table-bordered table-lg table-v2 table-striped mt-3">
                    <thead>
                      <th>Active</th>
                      <th>Name</th>
                      <th>Template</th>
                    </thead>
                    <tbody>
                    <tr v-for="sport in list">
                      <td><input type="checkbox" v-model="sport.active" />
                      </td>
                      <td>
                        <div  style="width: 250px;">
                          {{ sport.name }}
                        </div>
                      </td>
                      <td class="row-actions w150">
                        <select style="width: 150px" name="x" class="form-control pull-right" v-model="sport.template">
                          <option v-for="c in templates" :value="c.id">{{ c.name }}</option>
                        </select>
                      </td>
                    </tr>
                    </tbody>
                  </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Feed from '@/mixins/feed.js'

  export default {
    name: 'Sports',
    mixins: [Feed],
    data () {
      return {
        status: 0,
        t: this.$root.t,
        isLoading: true,
        list: null,
        templates: null
      }
    },
    watch: {
      'marketGroups' () {
      }
    },
    mounted () {
      this.fetchSportList();

      this.fetchTemplates().then(response => {
          this.templates = response.body.result
      })
    },
    methods: {
      fetchSportList() {
          this.fetchSport().then(response => {
            this.isLoading = false;
            this.list = response.body;
          });
      },
      saveSportPost() {
        this.saveSport(this.list).then(response => {
                this.$root.$notify({
                    group: 'custom-template',
                    text: this.t.processing.success,
                    type: 'success',
                    duration: 1000,
                    speed: 1000,
                    data: {}
                })
            })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/feed/sports/sports.vue